import { useEffect } from 'react';

const SEO = ({ title, description }) => {
    useEffect(() => {
        const baseTitle = "Electrospinning Community Data";
        document.title = title ? `${title} | ${baseTitle}` : baseTitle;

        if (description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute('content', description);
            } else {
                metaDescription = document.createElement('meta');
                metaDescription.name = "description";
                metaDescription.content = description;
                document.getElementsByTagName('head')[0].appendChild(metaDescription);
            }
        }
    }, [title, description]);

    return null;
};

export default SEO;
